<template>
  <div class="hardware-main">
    <div class="hardware-box">
      <div class="hardware-title">{{ $t('hardsix.mechanical') }}</div>
      <div class="hardware-li">{{ $t('hardsix.channelSize') }}</div>
      <div class="hardware-li">{{ $t('hardsix.conveyorLoad') }}</div>
      <div class="hardware-li">{{ $t('hardsix.maxCarton') }}</div>
      <div class="hardware-li">{{ $t('hardsix.conveyorType') }}</div>
      <div class="hardware-li">{{ $t('hardsix.customizable') }}</div>
      <div class="hardware-title">{{ $t('hardsix.electrical') }}</div>
      <div class="hardware-li">{{ $t('hardsix.powerSource') }}</div>
      <div class="hardware-li">{{ $t('hardsix.powerConsumption') }}</div>
      <div class="hardware-li">{{ $t('hardsix.controlSystem') }}</div>
      <div class="hardware-li">{{ $t('hardsix.pcSpecs') }}</div>
      <div class="hardware-li">{{ $t('hardsix.collisionPhotoelectric') }}</div>
      <div class="hardware-li">{{ $t('hardsix.baojing') }}</div>
      <div class="hardware-title">{{ $t('hardsix.rfid') }}</div>
      <div class="hardware-li">{{ $t('hardsix.readerModel') }}</div>
      <div class="hardware-li">{{ $t('hardsix.antennaModel') }}</div>
      <div class="hardware-li">{{ $t('hardsix.detectionQuantity') }}</div>
      <div class="hardware-li">{{ $t('hardsix.shieldingMethod') }}</div>
      <div class="hardware-li">{{ $t('hardsix.shieldingPerformance') }}</div>
      <div class="hardware-li">{{ $t('hardsix.customizableDoors') }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
</style>